<script>
  import {
    VList
  } from 'vuetify/lib'
  export default {
    name: 'wh-list',
    extends: VList
  };
</script>